import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';
import { EmptyComponent } from '@shared/empty/empty.component';

const routes: Routes = [
  ...environment.routes,
  { path: '**', component: EmptyComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class MncDocumentRoutingModule { }
